import { Paper, PaperProps, styled } from "@mui/material";
import React from "react";
import { pxToRem } from "../../../utils/fontSizeUtility";
import { breakpointValues, customBreakpoints } from "../../../styles/breakpoints";
import { chatWindowMaxWidth } from "../../../styles/theme";

export const ChatWindowPaper = styled(Paper)<PaperProps>(() => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  position: "relative",
  marginTop: "1px",
  maxWidth: `${chatWindowMaxWidth}px`,
  paddingLeft: pxToRem(16),
  paddingRight: pxToRem(16),
  [customBreakpoints.up(breakpointValues.md)]: {
    marginTop: 0,
  },
})) as React.ComponentType<PaperProps>;
